import { Injectable } from "@angular/core";
import { Adapter } from "../Interfaces/adapter";

export class UserInfo {
    constructor(
        public userInfoTable: string ,
        public userID: number,
        public userPNumber: string,
        public userName: string,
        public userType: string,
        public active: boolean,
        public modifiedByUserID? : number,
        public modifiedByUser? : string,
        public addedByUserID? : number,
        public addedByUser? : string,
    ) {}
}

@Injectable ({
    providedIn: 'root'
})

export class UserInfoAdapter implements Adapter<UserInfo> {
    adapt(item: any): UserInfo {
        return new UserInfo(
            item.userInfoTable,
            item.userID,
            item.userPNumber,
            item.userName,
            item.userType,
            item.active,
            item.modifiedByUserID,
            item.modifiedByUser,
            item.addedByUserID,
            item.addedByUser
        );
    }
}

